import { TZDate } from "@date-fns/tz";

export function timestampToDate(timestamp: number, timezone?: string | null) {
  return timezone
    ? new TZDate(timestamp).withTimeZone(timezone)
    : new Date(timestamp);
}

export const getDateString = (d: Date) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
